export default __webpack_public_path__ + "static/media/ITOPM-booked.08a21623.svg";